import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext({ content: {}, reload: () => {} });

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const reload = useCallback(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return (
    <ContentContext.Provider value={{ content, reload }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
export const useCopy = (key, fallback = "") => {
  const { content } = useContent();
  const v = content[key];
  return v && String(v).trim() ? v : fallback;
};
